// extracted by mini-css-extract-plugin
export default {"root":"jBik3","category":"xiPJx","coinsTab":"bAGby","landscapeCoinsWithGifts":"o1DNw","scrollbar":"jUhs4"};